<template>
  <div
    class="employee-to-primary-assignment-bar"
    role="img"
    :aria-label="accessibleLabel"
  >
    <div class="employee-to-primary-assignment-bar__identity">
      <ExAvatar
        class="employee-to-primary-assignment-bar__avatar"
        :picture="avatar || ''"
        :firstName="firstName"
        :lastName="lastName"
        size="small"
      />
      <p class="employee-to-primary-assignment-bar__name">{{ displayName }}</p>
    </div>
    <p class="employee-to-primary-assignment-bar__fte">{{ fteLabel }}</p>
  </div>
</template>

<script setup>
import { computed } from "vue";
import ExAvatar from "@components/common/ExAvatar.vue";
import { formatAssignmentFte, formatAssignmentName } from "./employeeToPrimaryAssignmentBarUtils";

const props = defineProps({
  firstName: {
    type: String,
    default: "",
  },
  lastName: {
    type: String,
    default: "",
  },
  avatar: {
    type: String,
    default: "",
  },
  fte: {
    type: [Number, String],
    default: 1,
  },
});

const displayName = computed(() => formatAssignmentName(props.firstName, props.lastName));
const fteLabel = computed(() => formatAssignmentFte(props.fte));
const accessibleLabel = computed(() =>
  displayName.value ? `${displayName.value}, ${fteLabel.value}` : fteLabel.value
);
</script>

<style scoped>
.employee-to-primary-assignment-bar {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  height: 38px;
  padding: 8px 10px 8px 8px;
  overflow: hidden;
  background: #f9fafb;
  border: 1px solid #eaecf0;
  border-radius: 6px;
}

.employee-to-primary-assignment-bar__identity {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1 1 auto;
}

.employee-to-primary-assignment-bar__avatar {
  flex-shrink: 0;
}

.employee-to-primary-assignment-bar__name,
.employee-to-primary-assignment-bar__fte {
  margin: 0;
  font-family: Inter, sans-serif;
  font-style: normal;
  line-height: normal;
  white-space: nowrap;
}

.employee-to-primary-assignment-bar__name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 500;
  color: #101828;
}

.employee-to-primary-assignment-bar__fte {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 400;
  color: #667085;
}
</style>
